import { useCallback } from 'react'
import { navigate } from 'gatsby'
import { dispatchAmplitudeEvent } from 'src/utils/amplitude'
import { getStandardObject } from 'src/utils/amplitude/getStandardObject'
import { useGlobalContext } from 'src/components/contexts/GlobalContext'

import { useCheckout } from '../checkout/useCheckout'

export const useCartToggleButton = () => {
  const { itemsTotal } = useCheckout()
  const { pageData } = useGlobalContext()
  const standardObj = getStandardObject(pageData)
  const onClick = useCallback(() => {
    dispatchAmplitudeEvent({
      eventName: 'Click Icons',
      eventData: {
        ...standardObj,
        'click name': 'open minicart',
      },
    })

    navigate('/checkout/cart')
  }, [standardObj])

  return {
    onClick,
    'data-testid': 'cart-toggle',
    'data-items': itemsTotal,
    itemsTotal,
  }
}
